import { validatePlatformContent } from "utils/newMediaValidation";

/**
 * Validates Twitter post content and media
 * @param {Object} params - The parameters for validation
 * @param {Array} params.thread - The Twitter thread content
 * @param {Object} params.platformMedia - Media objects for all platforms
 * @param {Number} params.monthlyPosts - Available monthly posts
 * @param {Number} params.twitterCharLimit - Twitter character limit
 * @returns {Object} - Validation results with errors and loading status
 */
const validateTwitter = ({
  thread,
  platformMedia,
  monthlyPosts,
  twitterCharLimit,
}) => {
  const errorList = [];
  const newMediaLoadingList = [];

  thread?.forEach((item, idx) => {
    const tweet = item?.content;
    //twttr.parseTweet(tweet) returns an object, and String(object) gives "[object Object]".
    const parsedTweet = !!tweet?.length ? tweet : "";
    const mediaList = platformMedia?.twitter?.[idx] ?? [];

    const { platformErrors, mediaList: mediaListValidated } =
      validatePlatformContent({
        mediaListRaw: mediaList,
        platform: "twitter",
        caption: parsedTweet,
        twitterCharLimit,
      });

    errorList.push(
      platformErrors.length > 0 ||
        mediaListValidated.some((media) => media.errors.length > 0)
    );

    if (mediaList?.length) {
      mediaList?.forEach((item) => newMediaLoadingList.push(!!item?.path));
    }

    errorList.push(monthlyPosts < 1);
  });

  return {
    hasError: errorList.includes(true),
    mediaLoadingList: newMediaLoadingList,
  };
};

export default validateTwitter;
